export default "__VITE_ASSET__234d28ba__"